import script from "./HeavyRichTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HeavyRichTable.vue?vue&type=script&setup=true&lang=js"

import "./HeavyRichTable.vue?vue&type=style&index=0&id=c07e50dc&lang=less"

const __exports__ = script;

export default __exports__